import { BaseDto } from "@models/base/baseDto.model";

export class UpdateTipoMovimientoRequest extends BaseDto{
    public resta!: boolean
    public editable!: boolean
    public esAnulable!: boolean
    public tieneComision!: boolean

    /** Ligature de Material Icons; null = usa el genérico */
    public icono!: string | null
}
